import React from "react";
import { useUser } from "../hooks/useUser";
import { Navigate, useLocation } from "react-router-dom";

const PrivateRoute = ({ children }) => {
  const { userEmail, loading } = useUser();
  const location = useLocation();

  if (loading) return null;
  if (!userEmail) return <Navigate to="/login" state={{ from: location }} replace />;

  return children;
};

export default PrivateRoute;
